import { Option, None } from '../option';
import { ArrayOps } from '../lift';
/**
 * Finds the first item in this Array satisfying a predicate.
 */
export function find(predicate) {
    var arr = this.value();
    for (var i = 0; i < arr.length; i++) {
        var item = arr[i];
        if (predicate(item, i))
            return Option(item);
    }
    return None;
}
ArrayOps.prototype.find = find;
